// extracted by mini-css-extract-plugin
export default {"document_detach_options":"DocumentDetachOptions_document_detach_options__lYQEs","document_detach_input":"DocumentDetachOptions_document_detach_input__R9wn7"};